(function () {
  'use strict';

  window.ImageUtils = window.ImageUtils || {};

  ImageUtils.getSrcImgForCharacter = function (currentAI) {
    if (currentAI && currentAI.avatar_file_name) {
      var avatarFileName = currentAI.avatar_file_name;

      if (avatarFileName) {
        avatarFileName = avatarFileName.replace(' ', '-');
      }
      avatarFileName = avatarFileName.trim();
      if (avatarFileName.indexOf('static/uploads') === -1) {
        avatarFileName = 'static/uploads/' + avatarFileName;
      }
      return 'https://netwrckstatic.netwrck.com/' + avatarFileName;
    } else {
      return 'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp';
    }
  };

  ImageUtils.getImageFileNameForAI = function (ai) {
    if (!ai) {
      return 'static/img/netwrck-logo-colord256.webp';
    }
    var fileName = ai.avatar_file_name || ai.AvatarFileName || '';
    if (fileName) {
      fileName = fileName.replace(/ /g, '-'); // Replace all spaces, not just first one
    }
    if (
      fileName &&
      fileName.trim() !== '' &&
      fileName !== 'None' &&
      fileName !== 'null'
    ) {
      if (fileName.indexOf('static/uploads') === -1) {
        fileName = 'static/uploads/' + fileName;
      }
      return fileName;
    }
    // Fallback to default logo
    return 'static/img/netwrck-logo-colord256.webp';
  };

  ImageUtils.preloadImage = function (imageName, onload) {
    var img = new Image();
    img.src = imageName;
    img.onload = onload;
  };

  ImageUtils.convertToWebP = function (imageUrl) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        try {
          const webpDataUrl = canvas.toDataURL('image/webp', 0.85);
          resolve(webpDataUrl);
        } catch (error) {
          reject(error);
        }
      };
      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = imageUrl;
    });
  };

  ImageUtils.getImageName = function (url) {
    if (!url) return '';

    var cleanUrl = url.split('?')[0];

    var parts = cleanUrl.split('/');
    return parts[parts.length - 1] || '';
  };

  ImageUtils.isSupportedImageFormat = function (fileName) {
    if (!fileName) return false;

    var supportedFormats = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'];
    var extension = fileName.toLowerCase().substr(fileName.lastIndexOf('.'));

    return supportedFormats.includes(extension);
  };

  ImageUtils.createImageElement = function (src, options) {
    options = options || {};

    var img = document.createElement('img');
    img.src = src;

    if (options.alt) img.alt = options.alt;
    if (options.className) img.className = options.className;
    if (options.width) img.width = options.width;
    if (options.height) img.height = options.height;
    if (options.loading) img.loading = options.loading;

    img.onerror = function () {
      if (options.fallback) {
        img.src = options.fallback;
      } else {
        img.src =
          'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp';
      }
    };

    return img;
  };
})();
